import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  d: "M0.59375 18.6265L8.99098 19.8428V11.8088H0.59375V18.6265ZM0.59375 10.6611H8.99098V2.62626L0.59375 3.8425V10.6611ZM10.1386 20.0091L21.4061 21.6411V11.8088H10.1386V20.0091ZM10.1386 2.45947V10.6611H21.4061V0.828369L10.1386 2.45947Z"
})), "IconMicrosoft");